import React, { FC } from 'react'
import TextField from '@mui/material/TextField'

import {
  TEXTFIELD_VARIANT_STANDARD,
  TEXTFIELD_VARIANT_FILLED,
  TEXTFIELD_VARIANT_OUTLINED,
} from '@kaidam/fc-shared/src/constants/mui'

import { getProps } from './utils'

import {
  FormFieldProps,
} from '../../../../types/frontend/form'

const Text: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {
  const {
    field: {
      name,
      value,
      onChange,
      onBlur
    },
    disabled,
    error,
    touched,
    item,
    readonly,

  } = getProps(props)
  const inputProps = item.inputProps || {}
  let useValue = typeof(value) === 'undefined' ? (item.default || '') : value
  if(useValue == '' && item.default) useValue = item.default

  return (
    <TextField
      fullWidth
      variant={ TEXTFIELD_VARIANT_STANDARD }
      inputProps={{
        style: {
          padding: '8px',
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
        },
      }}
      id={ name }
      name={ name }
      label={ item.title || item.id }
      helperText={ touched && error ? error : item.helperText }
      error={ touched && Boolean(error) }
      value={ typeof(useValue) == 'string' || typeof(useValue) == 'number' ? useValue : '' }
      disabled={ readonly || disabled }
      onChange={ onChange }
      onBlur={ onBlur }
      { ...inputProps }
    />
  )
}

export default Text